import { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { OperationProvider } from "../../../../../contexts/OperationContext";
import { selectTenantId } from "../../../../../util/store/selectors";
import { getStore } from "../../../../../util/store/store";
import { IVessel } from "../../../../../util/varibles/interface";
import { selectPlan } from "../../../constants";
import { planOpActions } from "../../../reducer";
import Operation from "./Operation";

export default function Operations({ vessels }: { vessels: IVessel[] }) {
    const vesselIds = useMemo(() => vessels.reduce((rs: Record<string, number>, item, i) => {
        rs[item.id] = i;
        return rs;
    }, {}), [vessels]);

    const operations = useSelector(selectPlan.ops);
    const level = useSelector(selectPlan.level);
    const userTenantId = useMemo(() => selectTenantId(getStore()), []);
    const dispatch = useDispatch();

    useEffect(() => {
        // let levelExample: ILevelByVessel2 = {};
        // Object.keys(operations).forEach(key => {
        //     levelExample = upLevel2(levelExample, operations[key], operations);
        // })
        // console.log(levelExample["264132c0-af04-4613-98ce-859f240e7f36"]);
    }, [operations])

    return <>
        {Object.keys(operations).map(key => {
            const item = operations[key];
            if (vesselIds[item.vessel.id] !== undefined) {
                const isOwn = item.operation.tenant_id === userTenantId;
                return <OperationProvider
                    key={item.operation.id}
                    isOwn={isOwn}
                    isDrag={isOwn}
                    data={item}
                    vesselIndex={vesselIds[item.vessel.id]}
                    level={level[item.vessel.id][item.operation.id]}
                    width={0}
                    vesselId={item.vessel.id}
                    vessels={vessels}
                    getOps={state => state.planOperation.operations}
                    updateOp={value => dispatch(planOpActions.updateOps({ update: { [item.operation.id]: { ...item, ...value } } }))}
                >
                    <Operation
                        key={key}
                        data={item}
                        level={level[item.vessel.id][item.operation.id]}
                    />
                </OperationProvider>
            }
            return null
        })}
    </>
}
